export default __webpack_public_path__ + "static/media/escape-regexp.04fafb46.cjs";